var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssessment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 70,
    viewBox: "0 0 92 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1855:23125)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 21.9841C25 19.7855 26.7724 18 28.9605 18H63.8339C66.023 18 67.7944 19.7845 67.7944 21.9841V66.1297C67.7944 68.3283 66.0219 70.1138 63.8339 70.1138H28.9605C26.7714 70.1138 25 68.3293 25 66.1297V21.9841ZM27.1689 66.1356V21.9782C27.1689 20.9822 27.9753 20.177 28.9586 20.177H63.8358C64.8223 20.177 65.6255 20.9851 65.6255 21.9782V66.1356C65.6255 67.1317 64.8229 67.9369 63.8327 67.9369H28.9617C27.973 67.9369 27.1689 67.1283 27.1689 66.1356Z",
    fill: "#00406B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2158 13.3478C41.9283 11.3974 43.8509 10 46.1109 10C48.3708 10 50.2934 11.3974 51.0059 13.3478H56.3704C57.3929 13.3478 58.2217 14.1767 58.2217 15.1991V23.2139C58.2217 24.2363 57.3929 25.0652 56.3704 25.0652H35.8513C34.8289 25.0652 34 24.2363 34 23.2139V15.1991C34 14.1767 34.8289 13.3478 35.8513 13.3478H41.2158Z",
    fill: "#FFE6A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 45.2857H59.6538L57.0385 38.2143L51.8077 48.5L47.2308 40.7857L42 53L36.1154 35L34.1538 45.2857H8",
    stroke: "#FECD51",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1855:23125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 70,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessment);
export default __webpack_public_path__ + "static/media/assessment.573da5635fe3b76efb36c4df5bfda7be.svg";
export { ForwardRef as ReactComponent };